module.exports = __webpack_public_path__ + "static/event2-93eeec420a448fbf1e06638f91196a92.jpeg";